import {initializeApp} from 'firebase/app';
import {
  browserSessionPersistence,
  connectAuthEmulator,
  getAuth,
  setPersistence,
} from 'firebase/auth';
import {runtimeConfig, verifiedAuthEmulator} from './config';

const app = initializeApp(runtimeConfig.firebase);
export const auth = getAuth(app);
void setPersistence(auth, browserSessionPersistence);

const emulator = verifiedAuthEmulator();
if (emulator) {
  connectAuthEmulator(auth, emulator, {disableWarnings: true});
  auth.settings.appVerificationDisabledForTesting = true;
}
